export const ABSTRACT_TEXT = "AbstractText";
export const COPYRIGHT_INFORMATION = "CopyrightInformation";
export const ARTICLE_TITLE = "ArticleTitle";
export const TAG = "tag";

export const DISPLAY_CLASS_DICT = {
  [ABSTRACT_TEXT]: "abstract-text",
  [COPYRIGHT_INFORMATION]: "copyright-text",
  [TAG]: "tag-text",
  [ARTICLE_TITLE]: "article-title",
};

export const DIV_ATTRS = {
  [COPYRIGHT_INFORMATION]: "div",
  [ABSTRACT_TEXT]: "div",
  [ARTICLE_TITLE]: "span",
  [TAG]: "span",
};
